import { render, staticRenderFns } from "./WorkCalendarTaskFrequencySettings.vue?vue&type=template&id=27f9bda8&scoped=true"
import script from "./WorkCalendarTaskFrequencySettings.vue?vue&type=script&lang=js"
export * from "./WorkCalendarTaskFrequencySettings.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarTaskFrequencySettings.vue?vue&type=style&index=0&id=27f9bda8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f9bda8",
  null
  
)

export default component.exports